<div class="report-dialog report-type-{{ data.reportDialogType }}">
  <div class="dialog-title" mat-dialog-title>
    @if (!data.title) {
      <span>
        @switch (data.reportDialogType) {
          @case (ReportDialogType.message) {
            <span>
              {{ 'components.reportDialog.messageDialogTitle' | translate : { action: data.action } }}
            </span>
          }
          @case (ReportDialogType.warning) {
            <span>
              {{ 'components.reportDialog.errorDialogTitle' | translate : { action: data.action } }}
            </span>
          }
          @case (ReportDialogType.error) {
            <span>
              {{ 'components.reportDialog.warningDialogTitle' | translate : { action: data.action } }}
            </span>
          }
        }
      </span>
    }
    @if (data.title) {
      <span>
        {{ data.title | translate }}
      </span>
    }
  </div>
  <div class="dialog-content" mat-dialog-content>
    @if (data.messages.length === 1) {
      <div>
        {{ data.messages[0] | translate }}
      </div>
    }
    @if (data.messages.length > 1) {
      <ul>
        @for (message of data.messages; track message) {
          <li>
            {{ message }}
          </li>
        }
      </ul>
    }
    @if (data.reportDialogType === ReportDialogType.warning) {
      <div class="caution-warning">
        {{ 'components.reportDialog.checkAndProceedWithCaution' | translate }}
      </div>
    }
  </div>
  <div align="end" mat-dialog-actions>
    @if (data.reportDialogType === ReportDialogType.message) {
      <button
        (click)="cancel()"
        color="primary"
        mat-flat-button
        >
        @if (data.buttonLabel) {
          <span>{{ data.buttonLabel }}</span>
        }
        @if (!data.buttonLabel) {
          <span>{{ 'general.cancel' | translate }}</span>
        }
      </button>
    }
    @if (data.reportDialogType !== ReportDialogType.message) {
      <button (click)="cancel()" mat-flat-button>
        @if (data.buttonLabel) {
          <span>{{ data.buttonLabel }}</span>
        }
        @if (!data.buttonLabel) {
          <span>{{ 'general.cancel' | translate }}</span>
        }
      </button>
    }
  </div>
</div>
